export const IndividualAccountIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="43"
    height="32"
    viewBox="0 0 43 32"
    fill="none"
  >
    <path
      d="M1.80693 1H33.5112C33.9535 1 34.3178 1.36427 34.3178 1.80659V24.4172C34.3178 24.8595 33.9535 25.2238 33.5112 25.2238H1.80693C1.36461 25.2238 1.00034 24.8595 1.00034 24.4172V1.80659C0.987328 1.36427 1.3516 1 1.80693 1Z"
      fill="white"
      stroke="black"
      strokeWidth="0.64"
      strokeMiterlimit="10"
    />
    <path d="M3.36816 10.6401H19.513H3.36816Z" fill="white" />
    <path
      d="M3.36816 10.6401H19.513"
      stroke="black"
      strokeWidth="0.64"
      strokeMiterlimit="10"
    />
    <path
      d="M3.36816 20.2411H9.76886"
      stroke="black"
      strokeWidth="0.64"
      strokeMiterlimit="10"
    />
    <path
      d="M12.9814 20.2281H20.9823"
      stroke="black"
      strokeWidth="0.64"
      strokeMiterlimit="10"
    />
    <path
      d="M8.16895 15.4406H20.9703"
      stroke="black"
      strokeWidth="0.64"
      strokeMiterlimit="10"
    />
    <path
      d="M4.29194 5.04597C4.73741 5.04597 5.09853 4.68484 5.09853 4.23938C5.09853 3.79391 4.73741 3.43279 4.29194 3.43279C3.84647 3.43279 3.48535 3.79391 3.48535 4.23938C3.48535 4.68484 3.84647 5.04597 4.29194 5.04597Z"
      fill="#1C1803"
    />
    <path
      d="M7.49214 5.04597C7.93761 5.04597 8.29873 4.68484 8.29873 4.23938C8.29873 3.79391 7.93761 3.43279 7.49214 3.43279C7.04667 3.43279 6.68555 3.79391 6.68555 4.23938C6.68555 4.68484 7.04667 5.04597 7.49214 5.04597Z"
      fill="#1C1803"
    />
    <path
      d="M10.6923 5.04597C11.1378 5.04597 11.4989 4.68484 11.4989 4.23938C11.4989 3.79391 11.1378 3.43279 10.6923 3.43279C10.2469 3.43279 9.88574 3.79391 9.88574 4.23938C9.88574 4.68484 10.2469 5.04597 10.6923 5.04597Z"
      fill="#1C1803"
    />
    <path
      d="M30.1025 31C36.5331 31 41.7461 25.787 41.7461 19.3565C41.7461 12.9259 36.5331 7.71292 30.1025 7.71292C23.672 7.71292 18.459 12.9259 18.459 19.3565C18.459 25.787 23.672 31 30.1025 31Z"
      fill="white"
      stroke="black"
      strokeWidth="0.64"
      strokeMiterlimit="10"
    />
    <path
      d="M30.2074 18.2637C32.0683 18.2637 33.5768 16.7551 33.5768 14.8942C33.5768 13.0333 32.0683 11.5247 30.2074 11.5247C28.3465 11.5247 26.8379 13.0333 26.8379 14.8942C26.8379 16.7551 28.3465 18.2637 30.2074 18.2637Z"
      fill="#CFCFCF"
    />
    <path
      d="M24.0003 25.575H36.4504C36.9188 25.575 37.257 25.1067 37.0879 24.6644C35.7089 21.1908 32.1963 19.1743 28.9179 19.7467C26.4071 20.1891 24.2865 22.1015 23.3628 24.6774C23.2067 25.1067 23.545 25.562 24.0003 25.562V25.575Z"
      fill="#CFCFCF"
    />
  </svg>
);

export const EntityAccountIcon = () => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="31"
    viewBox="0 0 32 31"
    fill="none"
  >
    <path
      d="M19.9979 5.93197V26.8435C19.9979 26.9027 19.9979 27.1986 19.7577 27.4452C19.6039 27.6031 19.4021 27.6918 19.1715 27.6918H1.82641C1.36516 27.6918 1 27.317 1 26.8435V1.8483C1 1.37483 1.37477 1 1.82641 1H15.7601L19.9979 5.94184V5.93197Z"
      fill="white"
      stroke="black"
      strokeWidth="0.71"
      strokeMiterlimit="10"
    />
    <path d="M21.8239 8.96997H17.7207V15.0659H21.8239V8.96997Z" fill="white" />
    <path
      d="M19.8059 5.92213H16.8077C16.2407 5.92213 15.7699 5.44866 15.7699 4.85682V1.33539C15.7603 1.24662 15.7411 1.14798 15.7314 1.0592"
      stroke="black"
      strokeWidth="0.71"
      strokeLinejoin="round"
    />
    <path d="M9.33105 7.35229H13.5208H9.33105Z" fill="white" />
    <path
      d="M9.33105 7.35229H13.5208"
      stroke="black"
      strokeWidth="0.71"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path d="M3.62402 7.35229H7.81375H3.62402Z" fill="white" />
    <path
      d="M3.62402 7.35229H7.81375"
      stroke="black"
      strokeWidth="0.71"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path d="M7.8125 9.35474H13.5205H7.8125Z" fill="white" />
    <path
      d="M7.8125 9.35474H13.5205"
      stroke="black"
      strokeWidth="0.71"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path d="M3.62402 9.35474H6.28585H3.62402Z" fill="white" />
    <path
      d="M3.62402 9.35474H6.28585"
      stroke="black"
      strokeWidth="0.71"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path d="M11.6191 11.3473H13.5218H11.6191Z" fill="white" />
    <path
      d="M11.6191 11.3473H13.5218"
      stroke="black"
      strokeWidth="0.71"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path d="M3.62402 11.3473H10.0912H3.62402Z" fill="white" />
    <path
      d="M3.62402 11.3473H10.0912"
      stroke="black"
      strokeWidth="0.71"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12.6951 30H3.54688V16.5752H12.6951V30Z"
      fill="white"
      stroke="black"
      strokeWidth="0.71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.8618 29.9704H12.7136C12.7136 24.7327 12.7039 19.4949 12.6943 14.2572C14.2511 13.4089 15.8174 12.5606 17.3741 11.7123C18.8636 12.5704 20.3435 13.4286 21.8329 14.2868C21.8425 19.5147 21.8522 24.7426 21.8618 29.9803V29.9704Z"
      fill="white"
      stroke="black"
      strokeWidth="0.71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.9998 8.94055H21.8516V29.9606H30.9998V8.94055Z"
      fill="white"
      stroke="black"
      strokeWidth="0.71"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M7.25494 19.1497H5.03516V20.5207H7.25494V19.1497Z" fill="black" />
    <path d="M11.2432 19.1497H9.02344V20.5207H11.2432V19.1497Z" fill="black" />
    <path d="M7.25494 22.464H5.03516V23.8351H7.25494V22.464Z" fill="black" />
    <path d="M11.2432 22.464H9.02344V23.8351H11.2432V22.464Z" fill="black" />
    <path d="M7.25494 25.7782H5.03516V27.1493H7.25494V25.7782Z" fill="black" />
    <path d="M11.2432 25.7782H9.02344V27.1493H11.2432V25.7782Z" fill="black" />
    <path d="M23.2646 23.332H29.5781H23.2646Z" fill="white" />
    <path
      d="M23.2646 23.332H29.5781"
      stroke="black"
      strokeWidth="0.42"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23.2646 21.369H29.5781H23.2646Z" fill="white" />
    <path
      d="M23.2646 21.369H29.5781"
      stroke="black"
      strokeWidth="0.42"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23.2646 19.3962H29.5781H23.2646Z" fill="white" />
    <path
      d="M23.2646 19.3962H29.5781"
      stroke="black"
      strokeWidth="0.42"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23.2646 17.4333H29.5781H23.2646Z" fill="white" />
    <path
      d="M23.2646 17.4333H29.5781"
      stroke="black"
      strokeWidth="0.42"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23.2646 15.4606H29.5781H23.2646Z" fill="white" />
    <path
      d="M23.2646 15.4606H29.5781"
      stroke="black"
      strokeWidth="0.42"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23.2646 13.4977H29.5781H23.2646Z" fill="white" />
    <path
      d="M23.2646 13.4977H29.5781"
      stroke="black"
      strokeWidth="0.42"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M23.2646 11.5249H29.5781H23.2646Z" fill="white" />
    <path
      d="M23.2646 11.5249H29.5781"
      stroke="black"
      strokeWidth="0.42"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
